import { observer } from 'mobx-react';
import * as React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { uuidv4generate } from '../Utils/UUID';

export type Placement =
    | 'auto-start'
    | 'auto'
    | 'auto-end'
    | 'top-start'
    | 'top'
    | 'top-end'
    | 'right-start'
    | 'right'
    | 'right-end'
    | 'bottom-end'
    | 'bottom'
    | 'bottom-start'
    | 'left-end'
    | 'left'
    | 'left-start';

export interface ITooltipProps {
    readonly placement?: Placement;
    readonly delay?: { show: number; hide: number } | number;
    readonly className?: string;
    readonly message: string | JSX.Element | undefined;
}

@observer
export class Tooltip extends React.Component<ITooltipProps> {
    public render() {
        return (
            <>
                <UncontrolledTooltip
                    placement={this.props.placement}
                    delay={this.props.delay}
                    target={this.id}
                    className={this.props.className}
                >
                    {this.props.message}
                </UncontrolledTooltip>

                <span id={this.id}>{this.props.children}</span>
            </>
        );
    }

    private id: string = 'id-' + uuidv4generate();
}
